import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { apiServices } from '../../services/apiServices'
import { useHistory } from "react-router-dom";
import axios from "axios";
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import { red } from '@material-ui/core/colors';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import AddIcon from '@material-ui/icons/Add';
import EventNoteIcon from '@material-ui/icons/EventNote';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import GetAppIcon from '@material-ui/icons/GetApp';
import GroupIcon from '@material-ui/icons/Group';
//import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useTranslation } from 'react-i18next';
import Customcaseslist from './Customcaseslist.js';
import OfflineDb from '../../db'
import { useSelector, useDispatch } from "react-redux"
import { Button } from '@dhis2/ui';
import Grid from '@material-ui/core/Grid';
//import { Configuration } from '../../assets/data/config'
import {useGlobalSpinnerActionsContext} from '../../context/GlobalSpinnerContext'
import '../../assets/css/customstyles.css'

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import TextField from '@material-ui/core/TextField';

import PersonIcon from '@material-ui/icons/Person';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
    margin: '0 auto',
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

function CustomeCaseCard(row) {
  const history = useHistory();
  const { t } = useTranslation();

  const [headers] = React.useState(row.searchHeader)
  const findIndexOfClientType = headers.findIndex(obj => obj.column.trim().toLocaleLowerCase() == "client type")
  const findIndexOfName = headers.findIndex(obj => obj.column.trim().toLocaleLowerCase() == "given name")
  const findIndexOfAddress = headers.findIndex(obj => obj.column.trim().toLocaleLowerCase() == "address")
  const clientType = row.row[findIndexOfClientType] ? row.row[findIndexOfClientType] : ""
  const clientTypeId = headers[findIndexOfClientType] ? headers[findIndexOfClientType].name : '';
  const clietName = row.row[findIndexOfName] ? row.row[findIndexOfName] : ""
  //const [vType] = useState(row.viewType)
  const findClientTreatmentType = headers.findIndex(obj => obj.column.trim().toLocaleLowerCase() == "types")
  const clientTreatmentType = row.row[findClientTreatmentType] ? row.row[findClientTreatmentType] : ""
  const regAddressId = headers[findIndexOfAddress] ? headers[findIndexOfAddress].name : '';
  const regAddress = findIndexOfAddress && row.row[findIndexOfAddress] ? row.row[findIndexOfAddress] : ""
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [UserBO, setUserBO] = useState(null);
  const [metaData, setMetaData] = useState(null)
  const setGlobalSpinner = useGlobalSpinnerActionsContext()
  //redux state selector and dispatch action
  const postResgistrationResponse = useSelector(state => state.postResgistrationResponse);
  const dispatch = useDispatch();
  const [Configuration,setConfiguration] = useState(null);
  async function getUserBO() {
    // let userdata = await OfflineDb.getDataFromPouchDB('loginDetails');
    // setUserBO(userdata.data)

    // let metaData = await OfflineDb.getDataFromPouchDB('metaData');
    // setMetaData(metaData.data)

    let configurations = await OfflineDb.getDataFromPouchDB('configurations')
    setConfiguration(configurations.data.configuration)
  }


  useEffect(() => {
    getUserBO();
  }, [])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const seeIndividualRecordClick = () => {

    localStorage.setItem('trackedEntityInstance', row.row[0])
    localStorage.setItem('linkContact', false)
    localStorage.setItem('hidebutton', true)


    setAnchorEl(null);
    setGlobalSpinner(true)
    history.push('/layout/individualrecord', { 'trackedEntityInstance': row.row[0] });
  }

  const addContcat = () => {
    const activeCaseFormData = {
      'formFormat': {
        [clientTypeId] : Configuration.ltbiLinkVariables.contact,
        [regAddressId] : regAddress ? regAddress : ''
      },
      'dhisFormat': null
    }
    const linkContact = {
      "enabled": true,
      "linkTrackedEntityInstance": row.row[0]
    }
    //OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
    OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
    OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)
    history.push('/layout/registration')
  }

  function getTreatmentServices(){
    console.log("row ",row);
    const activeCaseDetails = {
      'trackedEntityInstance': row.row[0],
      'enrollmentId': "",
      'caseType': "treatment cases",
      'redirectfrom': 'treatmentcases',
      "type": clientTreatmentType
    }
    OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
    history.push('/layout/registration')
  }
  function UpdateRecordClick() {
    setGlobalSpinner(true)
    if(row.searchFilter) {// ONLY FOR SPECIMEN SEARCH
      localStorage.setItem('specimen', JSON.stringify(row.searchFilter))
    }
    const formDataMassaged = {}

    row.metaData.programs[0].programTrackedEntityAttributes.map(field => {
      const fieldId = field.trackedEntityAttribute.id
      const fieldValue = row.row[row.searchHeader.findIndex(obj => obj.name == field.trackedEntityAttribute.id)]
      
      
      formDataMassaged[fieldId]= fieldValue
    })
    const activeCaseDetails = {
      'trackedEntityInstance': row.row[0],
      'enrollmentId': "",
    }
    const activeCaseFormData = {
      'formFormat': null, //formDataMassaged,
      'dhisFormat': null
    }
    const linkContact = {
      "enabled": false,
      "linkTrackedEntityInstance": row.row[0]
    }
    OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
    // OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
    OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)
    setGlobalSpinner(false)
    history.push('/layout/registration')

    // localStorage.setItem('trackedEntityInstance', row.row[0])
    // localStorage.setItem('linkContact', false)
    // dispatch({
    //   type:"REGISTRATION_RESPONSE_SAVE",
    //   payload:{
    //     'trackedEntityInstance': row.row[0],
    //     'enrollmentId': '',
    //     'showStage': true,
    //     'individualList': ""
    //   }
    // })
    // setAnchorEl(null);
    // history.push('/layout/registration');

    /* ---------------old code commented for customisation-------------- 

    const getChildrenById = (relationshipsArr, programid) => {
      let p = [];
      //this.setState({ loading: true });
      relationshipsArr.map((relobj) => {
        let url = `trackedEntityInstances/${relobj.to.trackedEntityInstance.trackedEntityInstance}.json?program=${programid}&fields=*?`;
        p.push(apiServices.getAPI(url));
      });

      return Promise.all([...p]).then(([...res]) => {
        let childrenArr = [...res];
        //this.setState({ loading: false });
        
        row.setPostResgistrationResponse({
          'trackedEntityInstance': row.row[0],
          'enrollmentId': '',
          'showStage': true,
          'individualList': childrenArr
        })
        history.push('/layout/registration');
      });
    }

    localStorage.setItem('trackedEntityInstance', row.row[0])
    localStorage.setItem('linkContact', false)



    //const UserBO = JSON.parse(localStorage.getItem('userBO'));    

    
    let orgID = UserBO.organisationUnits[0].id,
      programID = UserBO.programs[0],
      url = `trackedEntityInstances/${row.row[0]}.json?program=${programID}&fields=relationships`;
    
    if (clientType == 'Household') {
      apiServices.getAPI(url).then(res => {

        
        getChildrenById(res.data.relationships, programID)


      })
    } else {
      row.setPostResgistrationResponse({
        'trackedEntityInstance': row.row[0],
        'enrollmentId': '',
        'showStage': true
      })
      history.push('/layout/registration');
    }
    setAnchorEl(null);*/
  }
  const getIndividualsList = () => {
    localStorage.setItem('trackedEntityInstance', row.row[0]);
    history.push('/layout/individual-cases-list',{ 'trackedEntityInstance': row.row[0] });
  }

  function downlaodReport () {
    
      const link = document.createElement('a');
      link.href = 'https://cdn.jsdelivr.net/gh/duretech/shared@master/PatientRecodDetails.pdf';
      link.setAttribute(
        'download',
        `FileName.pdf`,
      );
      link.setAttribute(
        "target",
        "_blank"
      );
  
      // Append to html link element page
      document.body.appendChild(link);
  
      // Start download
      link.click();
  
      // Clean up and remove the link
      link.parentNode.removeChild(link);
  }
      
  
   
  
  const caseListView = () => {
    return (
      <Grid item xs={12} sm={12} md={12} className="knowkedgelistcontainer">
        {row.clientTabType && (row.clientTabType == "LTBI" || row.clientTabType == "TB") ?
          <Accordion square expanded={row.expanded === `panel1${row.index}`} onClick={getTreatmentServices}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel1bh-content${row.index}`}
            id={`panel1bh-header${row.index}`}
            
          >
            <Typography className={classes.heading} style={{paddingTop:"10px"}}><EventNoteIcon /></Typography>
              <Typography style={{padding: '10px 15px'}}>
                {clietName}
                </Typography>
          </AccordionSummary>
          </Accordion>
          :
          <Accordion square expanded={row.expanded === `panel1${row.index}`} onChange={row.handleChange(`panel1${row.index}`)}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`panel1bh-content${row.index}`}
          id={`panel1bh-header${row.index}`}
          
        >
          <Typography className={classes.heading} style={{paddingTop:"10px"}}><EventNoteIcon /></Typography>
            <Typography style={{padding: '10px 15px'}}>
              {clietName}
              </Typography>
        </AccordionSummary>
          <AccordionDetails>
          {/* alertsdetailholder */}
            <div className="">
            <Customcaseslist row={row} viewType={row.viewType}></Customcaseslist>
            <p className="alerts_profilebtn_holder caselistviewbtnholder myClientsCaseList">
              <Button variant="contained" color="primary" disableElevation className="infoviewmorebtn" onClick={seeIndividualRecordClick}>
                <VisibilityIcon /><span className="ml-10px"></span>
              </Button>
              <Button variant="contained" color="primary" disableElevation className="infoviewmorebtn ml-10px" onClick={UpdateRecordClick}>
                <EditIcon /> <span className="ml-10px"></span>
              </Button>
              { 
                Configuration.myclients && Configuration.myclients.enableDownloadReport 
                  ? 
                    <Button variant="contained" color="primary" disableElevation className="infoviewmorebtn ml-10px" onClick={downlaodReport}>
                      <GetAppIcon /> <span className="ml-10px"></span>
                    </Button>
                  :
                    <> </>  
              }
              
              {clientType && clientType.toLocaleLowerCase() == 'index' ?
                <>
                  <Button variant="contained" color="primary" disableElevation className="infoviewmorebtn ml-10px hide1" onClick={getIndividualsList}>
                    <PeopleAltIcon />{/* <span className="ml-10px">{t('Linked contacts')}</span> */}
                  </Button>
                  <Button variant="contained" color="primary" disableElevation className="infoviewmorebtn ml-10px hide1" onClick={addContcat}>
                    <PersonAddIcon />{/* <span className="ml-10px">{t('Add contact')}</span> */}
                  </Button>
                </>
              :<></>
              }
              {
                // (clientType && clientType.toLocaleLowerCase() != 'index') && (clientTreatmentType && (clientTreatmentType == "LTBI" || clientTreatmentType == "TB")) ?
                // <>
                //   <Button variant="contained" color="primary" disableElevation className="infoviewmorebtn ml-10px hide1" onClick={getTreatmentServices}>
                //     <LocalHospitalIcon />{/* <span className="ml-10px">{t('Linked contacts')}</span> */}
                //   </Button>
                // </>
                // :<></>
              }
            </p>
          </div>
        </AccordionDetails>
      </Accordion>
      }
      </Grid>
    )
  }

  const caseCardView = () => {
    
    return (
      <Grid item xs={12} sm={6} md={row.parentPage &&  row.parentPage == "registration"? 6 : 3}>
        <Card className={classes.root}>
          <CardHeader
            className="casescardheader"
            avatar={
              <Avatar aria-label="recipe" className={classes.avatar}>
                <EventNoteIcon />
              </Avatar>
            }
            action={
              <div>
                {row.hideOptions != 'true' ? <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
                  <MoreVertIcon />
                </IconButton > : <> </>}

                <Menu
                  id="simple-menu"
                  className="casesactionmenu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem onClick={() =>seeIndividualRecordClick()}><VisibilityIcon /> {t('See Individual Record')}</MenuItem>
                  <MenuItem onClick={() =>UpdateRecordClick()}><EditIcon /> {t('New/Update Individual Record')}</MenuItem>
                </Menu>
              </div>
            }
            title={clietName}
            subheader=""
          />

          <CardContent className="zero caselistholder">
            <Customcaseslist row={row} viewType={row.viewType}></Customcaseslist>
          </CardContent>
          <CardActions disableSpacing className="cardactionfooter">
            {row.hideOptions != 'true' ?
              <>
                <IconButton aria-label="add to favorites" onClick={seeIndividualRecordClick}>
                  <VisibilityIcon />
                </IconButton>
                <IconButton aria-label="share" onClick={UpdateRecordClick}>
                  <EditIcon />
                </IconButton> </> : <> </>}
            {clientType && clientType.toLocaleLowerCase() == 'index' ?
              <>
                <IconButton aria-label="share" className="hide1" title="Individuals List" onClick={getIndividualsList}>
                  <GroupIcon />
                </IconButton> <button className="caseSearchButton hide1" type="button" onClick={addContcat}>{t('Add contact')}</button>
              </> :
              <> </>}

            <IconButton
              className={clsx(classes.expand, {
                [classes.expandOpen]: expanded,
              })}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
            >
            </IconButton>
          </CardActions>
        </Card>
      </Grid>
    )
  }

  return (
    <>
      {Configuration ? 
        row.viewType == 'card' ? caseCardView() : caseListView()
      :<></>}
    </>
  )
}

export default CustomeCaseCard;